import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { AutomationPreview } from "../types/automation.types"

interface FullPreviewModalProps {
  open: boolean
  preview: AutomationPreview | null
  onClose: () => void
}

function HeaderRow({ label, value }: { label: string; value: string }) {
  return (
    <div className={"flex gap-2"}>
      <dt className={"w-20 shrink-0 text-gray-500"}>{label}</dt>
      <dd className={"min-w-0 break-words"}>{value}</dd>
    </div>
  )
}

export function FullPreviewModal({ open, preview, onClose }: FullPreviewModalProps) {
  const { t } = useTranslation()
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={t("settingsAutomation.review.preview.heading")}
      width={720}
    >
      {preview && (
        <div className={"flex flex-col gap-4"}>
          <dl className={"flex flex-col gap-1 border-b border-gray-200 pb-3"}>
            <HeaderRow label={t("settingsAutomation.review.preview.from")} value={preview.from} />
            <HeaderRow
              label={t("settingsAutomation.review.preview.replyTo")}
              value={preview.reply_to}
            />
            <HeaderRow
              label={t("settingsAutomation.review.preview.subject")}
              value={preview.subject}
            />
          </dl>
          {/* `html` is sanitized by the backend preview renderer before it is
              returned, so it is safe to inject here. */}
          <div
            className={"rich-text-content break-words"}
            dangerouslySetInnerHTML={{ __html: preview.html }}
          />
        </div>
      )}
    </Modal>
  )
}
